"use client";

import { Link } from "@faire/web/ui/LinkAnchor";
import React, { ReactNode } from "react";

// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import {
  ProductClickForSearchPageParameters,
  useOnProductClickForSearchPage,
} from "../../ComposableProductTile/__internal__/__internal__/productTileActions/useOnProductClickForSearchPage";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { useProductUrl } from "../../ComposableProductTile/__internal__/__internal__/useProductUrl";

interface IInsiderLinkClientWrapperProps {
  brandToken: string | undefined;
  productUrl?: string;
  selectedProductOptionToken?: string;
  dataTestId?: string;
  trackingParams?: ProductClickForSearchPageParameters;
  onLinkClickHandler?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
  children: ReactNode;
}

export const InsiderLinkClientWrapper: React.FC<
  IInsiderLinkClientWrapperProps
> = ({
  brandToken,
  selectedProductOptionToken,
  dataTestId,
  trackingParams,

  children,
}) => {
  const productUrl = useProductUrl({
    token: trackingParams?.token,
    brandToken: brandToken,
    impressionId: trackingParams?.impressionId,
    selectedProductOptionToken: selectedProductOptionToken,
  });
  const onLinkClickHandler = useOnProductClickForSearchPage(
    trackingParams ?? {}
  ).onProductClick;

  return (
    <Link
      onClick={onLinkClickHandler}
      data-test-id={dataTestId}
      to={productUrl ?? ""}
    >
      {children}
    </Link>
  );
};
